export default __webpack_public_path__ + "static/header-f73b0803e070363c539b1b3c8e36f3c0.jpeg";